module.exports = __webpack_public_path__ + "img/join_btn.782d7106.png";